import { Palette } from '@core/config/constants';

/** Configuracion especifica del minijuego de ritmo. Aislada del resto del juego. */
export const RhythmConfig = {
  key: 'RhythmScene',
  title: 'Ritmo Pop',
  description: 'Toca las estrellas al compas antes de que desaparezcan.',
  icon: '🎵',
  color: Palette.primary,

  /** Duracion de la partida en milisegundos. */
  roundDurationMs: 30_000,
  /** Cada cuanto aparece una nueva estrella (ms). */
  spawnIntervalMs: 850,
  /** Tiempo de vida de cada estrella antes de desaparecer (ms). */
  noteLifetimeMs: 1_400,
  /** Radio de la estrella tocable. */
  noteRadius: 60,
  /** Puntos base por acierto. */
  pointsPerHit: 10,
  /** Bonus por mantener combo. */
  comboBonus: 2,
  /** Combos necesarios para subir 1 al multiplicador. */
  comboPerMultiplier: 5,
  /** Multiplicador maximo de combo. */
  maxMultiplier: 5,
  /** Puntos extra por acertar en el momento "Perfecto". */
  perfectBonus: 8,
  /** Probabilidad de que una nota sea dorada (vale el doble). */
  goldenChance: 0.08,
  /** Multiplicador de las notas doradas. */
  goldenMultiplier: 2,
  /** Monedas otorgadas al finalizar por cada 100 puntos. */
  coinsPer100Points: 1,
} as const;

/**
 * Parametros de cada nivel de dificultad del minijuego de ritmo. La aparicion de notas se
 * calcula a partir del compas de la cancion (beatsPerNote y lifetimeBeats), asi el juego va
 * "al ritmo" tanto con musica real como con la generada por codigo.
 */
export interface RhythmDifficulty {
  readonly key: string;
  readonly label: string;
  readonly color: number;
  /** Cada cuantos pulsos aparece una nota (2 = una cada 2 pulsos; 0.5 = dos por pulso). */
  readonly beatsPerNote: number;
  /** Cuantos pulsos dura el anillo en cerrarse (ventana para tocar). */
  readonly lifetimeBeats: number;
  readonly roundDurationMs: number;
}

export const RHYTHM_DIFFICULTIES: readonly RhythmDifficulty[] = [
  { key: 'easy', label: '😊 Fácil', color: Palette.accent, beatsPerNote: 2, lifetimeBeats: 3, roundDurationMs: 30_000 },
  { key: 'normal', label: '⭐ Normal', color: Palette.secondary, beatsPerNote: 1, lifetimeBeats: 2.5, roundDurationMs: 30_000 },
  { key: 'hard', label: '🔥 Difícil', color: Palette.primary, beatsPerNote: 0.5, lifetimeBeats: 1.75, roundDurationMs: 35_000 },
];
